import { z } from "zod";

import {
  ActivationStatusSchema,
  ActivationTypeSchema,
  ReferralRewardStatusSchema
} from "../models/generated";

/* ------------------------------------------------------------- */
/* Agent tree types                                               */
/* ------------------------------------------------------------- */

export const MiniActivationSchema = z.object({
  type: ActivationTypeSchema,
  status: ActivationStatusSchema
});
export type MiniActivation = z.infer<typeof MiniActivationSchema>;

export const AgentTreeNodeSchema: z.ZodType<AgentTreeNode> = z.lazy(() =>
  z.object({
    accountId: z.string(),
    name: z.string().nullable(),
    email: z.string().nullable(),
    activations: z.array(MiniActivationSchema),
    children: z.array(AgentTreeNodeSchema)
  })
);

export interface AgentTreeNode {
  accountId: string;
  name: string | null;
  email: string | null;
  activations: MiniActivation[];
  children: AgentTreeNode[];
}

export const AgentTreeSchema = z.object({
  accountId: z.string(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  activations: z.array(MiniActivationSchema),
  treeSize: z.number(),
  children: z.array(AgentTreeNodeSchema)
});
export type AgentTree = z.infer<typeof AgentTreeSchema>;

/* ------------------------------------------------------------- */
/* Managed candidate                                              */
/* ------------------------------------------------------------- */

export const ManagedCandidateSchema = z.object({
  accountId: z.string(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  activationStatus: ActivationStatusSchema,
  referralCode: z.string(),
  activeApplications: z.number(),
  createdAt: z.coerce.date()
});
export type ManagedCandidate = z.infer<typeof ManagedCandidateSchema>;

/* ------------------------------------------------------------- */
/* Agent stats                                                    */
/* ------------------------------------------------------------- */

export const AgentStatsSchema = z.object({
  totalCandidates: z.number(),
  activeApplications: z.number(),
  pendingCommissions: z.number(),
  treeSize: z.number()
});
export type AgentStats = z.infer<typeof AgentStatsSchema>;

/* ------------------------------------------------------------- */
/* Agent commissions query                                        */
/* ------------------------------------------------------------- */

export const AgentCommissionsQuerySchema = z.object({
  page: z.coerce.number().min(0).default(0),
  limit: z.coerce.number().min(1).default(10),
  status: ReferralRewardStatusSchema.optional()
});
export type AgentCommissionsQuery = z.infer<typeof AgentCommissionsQuerySchema>;

/* ------------------------------------------------------------- */
/* Managed candidates query                                       */
/* ------------------------------------------------------------- */

export const ManagedCandidatesQuerySchema = z.object({
  page: z.coerce.number().min(0).default(0),
  limit: z.coerce.number().min(1).default(10),
  search: z.string().optional()
});
export type ManagedCandidatesQuery = z.infer<typeof ManagedCandidatesQuerySchema>;
